<div class="fs-sm block-content-round ion-margin-top-0">
  <ion-row>
    <ion-col
      size="12"
      size-lg="6"
    >
      <div class="freight-data-block">
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/payments_24dp.svg"
        ></ion-icon>
        <div>
          <p class="subtitle">{{ 'freight.detail.price' | translate }}</p>
          <p>
            <span
              class="price"
              [class.notAvailable]="isNotAvailable()"
              [class.availableWithConditions]="isAvailableWithConditions()"
              [class.fullyAvailable]="isFullyAvailable()"
              >{{ freight().price | number: '1.2-2' }} €</span
            >
          </p>
        </div>
      </div>
    </ion-col>

    <ion-col
      size="12"
      size-lg="6"
    >
      <div class="freight-data-block">
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/barcode_24dp.svg"
        ></ion-icon>
        <div>
          <p class="subtitle">{{ 'freight.detail.okcargo_reference' | translate }}</p>
          <p>{{ freight().reference }}</p>
        </div>
      </div>
    </ion-col>
  </ion-row>
</div>

<div class="stops-resume fs-sm block-content-round ion-margin-top-0">
  <ion-row>
    <ion-col
      size="6"
      class="from"
    >
      <p class="subtitle">{{ 'freight.detail.origin' | translate }}</p>
      <p class="date">{{ freight().stops[0].since | dfnsFormat: 'ccc P' }}</p>
      @if (isFullyAvailable() || isAvailableWithConditions()) {
        <p>{{ freight().stops[0].address.postalCode }} {{ freight().stops[0].address.city }}</p>
      }
      <p class="state state--from">
        ({{ freight().stops[0].address.countryCode }})
        {{ 'states.' + freight().stops[0].address.countryCode + freight().stops[0].address.stateCode | translate }}
      </p>
    </ion-col>
    <ion-col
      size="6"
      class="ion-text-end to"
    >
      <p class="subtitle">{{ 'freight.detail.destination' | translate }}</p>
      <p class="date">{{ freight().stops[freight().stops.length - 1].since | dfnsFormat: 'ccc P' }}</p>
      @if (isFullyAvailable() || isAvailableWithConditions()) {
        <p>
          {{ freight().stops[freight().stops.length - 1].address.postalCode }}
          {{ freight().stops[freight().stops.length - 1].address.city }}
        </p>
      }
      <p class="state state--to">
        ({{ freight().stops[freight().stops.length - 1].address.countryCode }})
        {{
          'states.' +
            freight().stops[freight().stops.length - 1].address.countryCode +
            freight().stops[freight().stops.length - 1].address.stateCode | translate
        }}
      </p>
    </ion-col>
  </ion-row>
</div>
